module.exports = __webpack_public_path__ + "static/img/A53.c5273033.jpg";